import * as React from "react";
import { Box, styled } from "@mui/material";
import { useSettings } from "../tools";
import { useClientSettings, useMediaDevices, useVolumeLevel } from "@dvrt/web-phone-client";

const Root = styled(Box)({
    display: "flex",
    flexDirection: "column-reverse",
    padding: "0.5em",
    alignItems: "flex-end",
});

const Bar = styled(Box, {
    shouldForwardProp: (prop) => prop !== "disabled",
})<{ disabled: boolean }>(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    flexGrow: 1,
    marginTop: 1,
    paddingTop: 1,
    width: 6,
    transition: "0.2s opacity",
    variants: [
        {
            props: ({ disabled }) => disabled,
            style: {
                backgroundColor: theme.palette.text.disabled,
            },
        },
    ],
}));

const barCount = 10;

export default () => {
    const settings = useSettings();
    const mediaDevices = useMediaDevices();
    const clientSettings = useClientSettings();
    const deviceId = clientSettings.selectedMediaDevices?.audioinput ?? mediaDevices.defaults.audioinput;
    const { volume } = useVolumeLevel(deviceId, settings.audio);
    const disabled = !settings.audio;

    return (
        <Root>
            {Array.from(Array(barCount).keys()).map((idx) => {
                const limit = (100 / barCount) * (idx + 1);
                return (
                    <Bar
                        disabled={disabled}
                        key={idx}
                        sx={[
                            volume > limit
                                ? {
                                      opacity: 1,
                                  }
                                : {
                                      opacity: 0.4,
                                  },
                        ]}
                    />
                );
            })}
        </Root>
    );
};
